module.exports = __webpack_public_path__ + "static/media/privacy-policy.783dc86f.svg";